import {QuestionOptionList} from "./QuestionOptionList";
import {QuestionOptionEdit} from "./QuestionOptionEdit";
import {QuestionOptionCreate} from "./QuestionOptionCreate";

export default {
    list: QuestionOptionList,
    create: QuestionOptionCreate,
    edit: QuestionOptionEdit
};
